<script setup>
const {images, visibleRef, indexRef, closeLightbox} = useLightbox()
</script>

<template>
  <vue-easy-lightbox
    :visible="visibleRef"
    :imgs="images"
    :index="indexRef"
    @hide="closeLightbox"
  />
</template>